import styled from 'styled-components';

const StyledRightColumn = styled.div`
    background-color: ${({ theme }) => theme.colors.blue};
    position: relative;
    min-height: 550px;
`;

export default StyledRightColumn;
